import mdl from '@/models/HumanResource/HrAbsenceRequest'

const createAbsenceRequest = async data => {
    let seat = new mdl(data)
    try {
        let response = await seat.save()
        return response
    } catch (error) {
        return error.response
    }
}

export { createAbsenceRequest }
